import type { Components, Theme } from '@mui/material';

export const MuiTableSortLabel: Components<Theme>['MuiTableSortLabel'] = {
  styleOverrides: {
    root: {
      gap: 4,
      '& .MuiSvgIcon-root': {
        fontSize: 16,
      },
    },
    icon: {
      display: 'none',
    },
  },
};
